import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { GCADAConfigService } from '@GCADA/services/config.service';
import { GCADANavigationService } from '@GCADA/components/navigation/navigation.service';
import { GCADASidebarService } from '@GCADA/components/sidebar/sidebar.service';
import { GCADASplashScreenService } from '@GCADA/services/splash-screen.service';
import { GCADATranslationLoaderService } from '@GCADA/services/translation-loader.service';

import { navigation } from 'app/navigation/navigation';
import { locale as navigationEnglish } from 'app/navigation/i18n/en';

@Component({
    selector   : 'app',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy
{
    GCADAConfig: any;
    navigation: any;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {DOCUMENT} document
     * @param {GCADAConfigService} _GCADAConfigService
     * @param {GCADANavigationService} _GCADANavigationService
     * @param {GCADASidebarService} _GCADASidebarService
     * @param {GCADASplashScreenService} _GCADASplashScreenService
     * @param {GCADATranslationLoaderService} _GCADATranslationLoaderService
     * @param {Platform} _platform
     * @param {TranslateService} _translateService
     */
    constructor(
        @Inject(DOCUMENT) private document: any,
        private _GCADAConfigService: GCADAConfigService,
        private _GCADANavigationService: GCADANavigationService,
        private _GCADASidebarService: GCADASidebarService,
        private _GCADASplashScreenService: GCADASplashScreenService,
        private _GCADATranslationLoaderService: GCADATranslationLoaderService,
        private _translateService: TranslateService,
        private _platform: Platform
    )
    {
        // Get default navigation
        this.navigation = navigation;

        // Register the navigation to the service
        this._GCADANavigationService.register('main', this.navigation);

        // Set the main navigation as our current navigation
        this._GCADANavigationService.setCurrentNavigation('main');

        // Add languages
        this._translateService.addLangs(['en', 'tr']);

        // Set the default language
        this._translateService.setDefaultLang('en');

        // Set the navigation translations
        this._GCADATranslationLoaderService.loadTranslations(navigationEnglish);

        // Use a language
        this._translateService.use('en');

        // Add is-mobile class to the body if the platform is mobile
        if ( this._platform.ANDROID || this._platform.IOS )
        {
            this.document.body.classList.add('is-mobile');
        }

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to config changes
        this._GCADAConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {

                this.GCADAConfig = config;
                // Color theme
                this.document.body.classList.add(this.GCADAConfig.colorTheme);
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

}
